// Shared types for the Student Exposure Visit feature.

export interface DropdownOption {
  label: string;
  value: string | number;
}

export interface StudentRow {
  user_id: string;
  name: string;
  class_studying_id: string | number;
  class_section?: string;
  section?: string;
  group_code_id?: string | number;
  group_name?: string;
  visit: string;
  IndxID: string;
  ExpotStatus: string;
  date_visit: string;
  ClgId: string;
  district?: string;
  hod_name?: string;
  instititute_name?: string;
  OtherClgId?: string;
  No_reason?: string;
  Other_Reason?: string;
  photo_upload?: string;
  video_upload?: string;
  [key: string]: any;
}

export interface CollegeItem {
  college_name: string;
  college_id: number;
  education_category: string | null;
  education_category_id: number | null;
  [key: string]: any;
}

// Individual form fields (Angular FormGroup → useState per field)
export interface ExposureForm {
  exposureVisit: string;
  collegeName: string | number | '';
  collegeCode: string | number | '';
  streemHOD: string;
  dist: string | number | '';
  visitDate: string;
  OtherClgId: string;
  reason: number | '';
  teacher1: number | '';
  teacher2: number | '';
  OtherReason: string;
}

export const EMPTY_FORM: ExposureForm = {
  exposureVisit: '',
  collegeName: '',
  collegeCode: '',
  streemHOD: '',
  dist: '',
  visitDate: '',
  OtherClgId: '',
  reason: '',
  OtherReason: '',
  teacher1: '',
  teacher2: '',
};

export interface TeacherItem {
  teacher_id: number;
  teacher_name: string;
  Designation?: string;
  [key: string]: any;
}
